import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get(`/kam/quality-checks`, options);

  return response;
};

export const get = async ({ _id }) => {
  const response = await api.get(`/kam/quality-checks/${_id}`);

  return response;
};

export const post = async (
  qualityCheck,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.post(
    "/kam/quality-checks",
    { qualityCheck },
    { params: { showMessage, ...restParams }, ...restOptions },
  );

  return response;
};

export const put = async (qualityCheck) => {
  const response = await api.put("/kam/quality-checks", { qualityCheck });

  return response;
};

export const cancel = async (payload) => {
  const response = await api.put("/kam/quality-checks/cancel", payload);

  return response;
};
